module.exports = __webpack_public_path__ + "img/b-1.3.9586da57.jpg";